import React from "react";
import CpwdTenderResultsPage from "./CpwdTenderResultsPage";

export default function CpwdTenderResultsClientPage() {
  return <CpwdTenderResultsPage admin={false} />;
}
